import api from './api';

export interface Integracao {
  id: string;
  nome: string;
  tipo: string;
  ativo: boolean;
  urlBase: string;
  apiKey?: string | null;
  config?: unknown;
  createdAt: string;
  updatedAt: string;
  _count?: { logs: number };
}

export interface IntegracaoInput {
  nome: string;
  tipo: string;
  ativo?: boolean;
  urlBase: string;
  apiKey?: string | null;
  config?: unknown;
}

export interface IntegracaoLog {
  id: string;
  integracaoId: string;
  tipoEvento: string;
  referenciaId?: string | null;
  status: 'pendente' | 'sucesso' | 'erro';
  tentativas: number;
  payload?: string | null;
  resposta?: string | null;
  erroMensagem?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IntegracaoLogListResponse {
  data: IntegracaoLog[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export const integracaoService = {
  async list(): Promise<Integracao[]> {
    const response = await api.get<Integracao[]>('/integrations');
    return response.data;
  },

  async create(data: IntegracaoInput): Promise<Integracao> {
    const response = await api.post<Integracao>('/integrations', data);
    return response.data;
  },

  async update(id: string, data: Partial<IntegracaoInput>): Promise<Integracao> {
    const response = await api.put<Integracao>(`/integrations/${id}`, data);
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/integrations/${id}`);
  },

  async test(id: string): Promise<{ ok: boolean; status?: number; data?: unknown; erro?: string }> {
    const response = await api.post(`/integrations/${id}/test`);
    return response.data;
  },

  async sync(): Promise<{ total: number; enviadas: number; erros: number; puladas: number }> {
    const response = await api.post('/integrations/sync');
    return response.data;
  },

  async logs(id: string, filters?: { status?: string; page?: number; limit?: number }): Promise<IntegracaoLogListResponse> {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());
    const response = await api.get<IntegracaoLogListResponse>(`/integrations/${id}/logs?${params}`);
    return response.data;
  },

  async retry(id: string, logId: string): Promise<unknown> {
    const response = await api.post(`/integrations/${id}/logs/${logId}/retry`);
    return response.data;
  },
};
